module.exports = __webpack_public_path__ + "img/friend_video_text.2d6978fd.png";